import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { getUserLanguage, resolveActiveAppLanguage } from '@shared/utils/userLanguage';

interface UserAppLanguage {
  userLanguage: string | null;
  activeAppLanguage: string;
}

const useUserLanguage = (): UserAppLanguage => {
  const { i18n } = useTranslation(i18nNameSpace.COMMON);
  const userLanguage = getUserLanguage();
  const activeAppLanguage = resolveActiveAppLanguage(userLanguage, i18n.language);

  return { userLanguage, activeAppLanguage };
};

export { useUserLanguage };
